<template>
  <div class="portal-page-fill checkin-details">
    <div class="checkin-manager" v-if="refinedRows">
      <div class="top-header toolbar-card">
        <div class="search">
          <div class="icon">
            <span class="mdi mdi-magnify"></span>
          </div>
          <input
            class="search-bar"
            :placeholder="$t('search.checkinplaceholder')"
            v-model="search"
          />
        </div>
        <div class="filters-container">
          <GateTabs :value="filter" @update="updatefilter" />
        </div>
        <div class="create-checkin">
          <span
            v-if="canCreateCheckinRow"
            @click="createNewRow"
            class="mdi mdi-plus-circle-outline add"
          ></span>
        </div>
      </div>
    </div>
    <div class="checkin-table portal-table-wrap table-card">
      <div class="portal-table-scroll">
        <table class="table">
        <thead>
          <tr class="table-header">
            <th
              class="user-table-headers"
              :class="[{ sorting: sort === 'name' }, direction]"
              @click="updateSort('name')"
            >
              Code
            </th>
            <th class="user-table-headers">
              Airline
            </th>
            <th
              class="user-table-headers"
              :class="[{ sorting: sort === 'status' }, direction]"
              @click="updateSort('status')"
            >
              Status
            </th>
            <th class="user-table-headers">
              Logo
            </th>
            <th
              class="user-table-headers"
              v-if="canEditCheckinRow || canDeleteCheckinRow"
            >
              Action
            </th>
          </tr>
        </thead>
        <PortalTableBody
          :loading="loading"
          variant="airline"
          :show-actions="canEditCheckinRow || canDeleteCheckinRow"
        >
          <tr v-for="(item, idx) in refinedRows" :key="item.id || idx">
            <td>{{ item.code }}</td>
            <td>{{ getAirlineName(item.airline_code) }}</td>
            <td>{{ rowStatusLabel(item) }}</td>
            <td>
              <img
                v-if="item.logo_file"
                :src="logoUrl(item.logo_file)"
                class="row-logo-icon"
                alt="Check-in row logo"
                @error="onLogoError"
              />
            </td>
            <td v-if="canEditCheckinRow || canDeleteCheckinRow">
              <div class="row d-flex justify-content-center">
                <div v-if="canEditCheckinRow" class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editRowDetails(idx)"
                  ></span>
                </div>
                <div v-if="canDeleteCheckinRow" class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(idx)"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="!loading && refinedRows.length === 0">
            <td
              :colspan="canEditCheckinRow || canDeleteCheckinRow ? 5 : 4"
              class="no-data-cell"
            >
              No check-in rows found
            </td>
          </tr>
        </PortalTableBody>
      </table>
      </div>
    </div>
    <div class="footer portal-footer">
      <div class="results">
        <span class="mdi mdi-format-list-bulleted results-icon" aria-hidden="true"></span>
        Displaying <strong>{{ resultsCopy }}</strong> results
      </div>
    </div>

    <!-- Pop Up Modal -->
    <div v-if="myModel">
      <transition name="model">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click="myModel = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="confirmation pb-4" style="text-align: center">
                    <h4>Are you sure you want to delete this check-in row?</h4>
                  </div>
                  <div align="center">
                    <input
                      type="button"
                      class="btn btn-primary"
                      style="margin-right: 10px; width: 100px"
                      value="OK"
                      @click="deleteRow(modalData)"
                    />
                    <input
                      type="button"
                      class="btn btn-danger"
                      style="margin-left: 10px; width: 100px"
                      value="Cancel"
                      @click="myModel = false"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import GateTabs from '../GateTabs.vue';
import PortalTableBody from '../PortalTableBody.vue';
import { routeNames } from '../../js/routeNames';
import axios from 'axios';
import { decryptData } from '../../js/utils/encrypt';
import moment from 'moment';

export default {
  data() {
    return {
      loading: false,
      myModel: false,
      rows: [],
      airlines: [],
      airlineMap: {},
      permissions: [],
      search: '',
      filter: 'all',
      modalData: '',
    };
  },
  props: {
    direction: String,
    sort: String,
  },
  components: {
    GateTabs,
    PortalTableBody,
  },
  computed: {
    routeNames: () => routeNames,
    refinedRows() {
      let refined = this.filterByTimeWindow(this.rows);
      refined = this.filterRows(refined);
      refined = this.searchRows(refined);
      refined = this.sortRows(refined);
      refined = this.direction === 'ascending' ? refined : refined.reverse();
      return refined;
    },
    resultsCopy() {
      const length = this.refinedRows.length;
      return `${length}`;
    },
    canCreateCheckinRow() {
      return this.permissions.includes('Create-CheckinRow');
    },
    canEditCheckinRow() {
      return this.permissions.includes('Edit-CheckinRow');
    },
    canDeleteCheckinRow() {
      return this.permissions.includes('Delete-CheckinRow');
    },
  },
  mounted() {
    let mkLocalData = localStorage.getItem('Permissions');
    if (!mkLocalData) {
      mkLocalData = 'null';
    }
    const secretPermissionKey = process.env.KEY || 'myscecretkey';
    this.permissions = decryptData(mkLocalData, secretPermissionKey);

    this.loading = true;
    axios
      .get(this.$hostName + '/airlines/details')
      .then((resp) => {
        this.airlines = (resp && resp.data) || [];
        this.airlineMap = {};
        this.airlines.forEach((a) => {
          if (a && a.code) {
            this.airlineMap[a.code] = a.name;
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(this.$hostName + '/checkin-rows')
      .then((response) => {
        this.rows = response.data;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    refreshPortalPage() {
      this.loading = true;
      axios
        .get(this.$hostName + '/checkin-rows')
        .then((response) => {
          this.rows = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filterByTimeWindow(data) {
      if (!Array.isArray(data) || !data.length) return data;
      const rollInMin = parseInt(process.env.VUE_APP_ROLLIN_CHECKIN_MIN, 10) || 0;
      const rollOutMin = parseInt(process.env.VUE_APP_ROLLOUT_CHECKIN_MIN, 10) || 0;
      // If both are zero, do not filter by time window
      if (!rollInMin && !rollOutMin) return data;

      const now = new Date();
      return data.filter((row) => {
        const raw = row && row.updated_at;
        if (!raw) return false;
        const m = moment.utc(raw);
        if (!m.isValid()) return false;
        const ts = m.toDate();

        const showFrom = new Date(ts.getTime() - rollInMin * 60 * 1000);
        const hideAfter = new Date(ts.getTime() + rollOutMin * 60 * 1000);
        return now >= showFrom && now <= hideAfter;
      });
    },
    filterRows(data) {
      if (this.filter !== 'all') {
        const filterVal = this.filter;
        return data.filter((row) => {
          // Normalize is_active to boolean: supports true/false, 1/0, '1'/'0'
          const active =
            row.is_active === true ||
            row.is_active === 1 ||
            row.is_active === '1';

          if (filterVal === '1') return active;
          if (filterVal === '0') return !active;
          return true;
        });
      }
      return data;
    },
    searchRows(data) {
      const rows = Array.isArray(data) ? data : [];
      if (!this.search) return rows;
      const q = this.search.toString().toLowerCase();
      return rows.filter((row) => {
        const code =
          row.code != null ? String(row.code).toLowerCase() : '';
        const airlineCode =
          row.airline_code != null ? String(row.airline_code).toLowerCase() : '';
        const airlineName = (this.getAirlineName(row.airline_code) || '')
          .toString()
          .toLowerCase();
        const status = this.rowStatusLabel(row).toLowerCase();
        const description =
          row.description != null
            ? String(row.description).toLowerCase()
            : '';
        const logo =
          row.logo_file != null ? String(row.logo_file).toLowerCase() : '';
        return (
          (code && code.includes(q)) ||
          (airlineCode && airlineCode.includes(q)) ||
          (airlineName && airlineName.includes(q)) ||
          status.includes(q) ||
          (description && description.includes(q)) ||
          (logo && logo.includes(q))
        );
      });
    },
    rowStatusLabel(row) {
      const active =
        row.is_active === true ||
        row.is_active === 1 ||
        row.is_active === '1';
      return active ? 'Enabled' : 'Disabled';
    },
    sortRows(data) {
      if (!this.sort) return data;
      switch (this.sort) {
        case 'name':
          return data.slice().sort((a, b) => {
            const aName = (a.code || '').toString().toLowerCase();
            const bName = (b.code || '').toString().toLowerCase();
            if (aName < bName) return -1;
            if (aName > bName) return 1;
            return 0;
          });
        case 'status':
          return data.slice().sort((a, b) => {
            const aStatus = a.is_active ? 1 : 0;
            const bStatus = b.is_active ? 1 : 0;
            if (aStatus < bStatus) return -1;
            if (aStatus > bStatus) return 1;
            return 0;
          });
        default:
          return data;
      }
    },
    updatefilter(value) {
      this.filter = value;
    },
    updateSort(value) {
      this.$emit('updateSort', value);
    },
    logoUrl(fileName) {
      if (!fileName) return '';
      if (/^https?:\/\//i.test(fileName)) return fileName;
      const base = process.env.VUE_APP_AIRLINE_IMAGES_BASE || process.env.VUE_APP_IMAGES_BASE || '';
      if (!base) return fileName;
      const trimmed = base.replace(/\/$/, '');
      return `${trimmed}/${String(fileName).replace(/^\//, '')}`;
    },
    onLogoError(e) {
      if (e && e.target) {
        e.target.style.display = 'none';
      }
    },
    getAirlineName(code) {
      if (!code) return '';
      return this.airlineMap[code] || code;
    },
    createNewRow() {
      this.$router.push({ name: routeNames.newCheckinRow });
    },
    editRowDetails(idx) {
      const row = this.refinedRows[idx];
      this.$router.push({
        name: routeNames.editCheckinRow,
        params: {
          id: row.id,
          code: row.code,
          airline_code: row.airline_code,
          description: row.description,
          logo_file: row.logo_file,
          is_active: row.is_active,
        },
      });
    },
    openModel(idx) {
      this.myModel = true;
      this.modalData = idx;
    },
    deleteRow(idx) {
      this.loading = true;
      axios
        .delete(this.$hostName + '/checkin-row/' + this.refinedRows[idx].id)
        .then((response) => {
          if (response.status === 200) {
            this.myModel = false;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getRows();
        });
    },
    getRows() {
      axios
        .get(this.$hostName + '/checkin-rows')
        .then((response) => {
          this.rows = response.data;
        })
        .finally(() => {
          this.loading = false;
          this.$alert('Check-in Row removed successfully');
        });
    },
  },
};
</script>

<style scoped lang="scss">
.no-data-cell {
  padding: 24px 8px;
  color: $general-black-light;
  font-style: italic;
}

.checkin-table {
  min-height: 0;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-content {
  width: 500px !important;
}


.icon {
  font-size: 25px;
}

.edit {
  color: #007bff;
  top: 5px;
  margin-right: 10px;
}

.edit:hover {
  cursor: pointer;
}

.delete {
  color: red;
  margin-left: 10px;
}

.delete:hover {
  cursor: pointer;
}

.row-logo-icon {
  max-width: 60px;
  max-height: 40px;
  object-fit: contain;
  display: inline-block;
}

.add:hover {
  cursor: pointer;
}

.checkin-manager {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
